import { action, computed, observable } from 'mobx'

export default class ShareView {
  rootStore = null

  @observable accessor isOpen = false
  @observable accessor shareData = {}
  @observable accessor dialogData = {}

  constructor(rootStore) {
    this.rootStore = rootStore
  }

  reset = () => {
    this.#setOpen(false)
    this.#setShareData({})
    this.#setDialogData({})
  }

  get fingerprint() {
    return this.rootStore.fingerprintStore
  }

  @computed
  get isSharing() {
    return this.shareData.text || this.shareData.title || this.shareData.url
  }

  @computed
  get canShareNatively() {
    return (
      this.fingerprint.isMobile &&
      this.isSharing &&
      navigator.canShare &&
      navigator.share &&
      navigator.canShare(this.shareData)
    )
  }

  @computed
  get isSharingUrl() {
    return Boolean(this.shareData.url)
  }

  @computed
  get urlOrTextValue() {
    return this.shareData.url || this.shareData.text
  }

  @computed
  get textOrNothing() {
    return this.isSharingUrl ? this.shareData.text : ''
  }

  share = async ({ dialogDescription, dialogTitle, text, title, url }) => {
    if (this.isSharing) {
      console.error('[Share] Already sharing')

      return
    }

    const data = { text, title, url }
    data.text ??= ''
    data.title ??= ''

    this.#setShareData(data)
    this.#setDialogData({ description: dialogDescription || '', title: dialogTitle || 'Share' })

    if (!this.canShareNatively) {
      this.#setOpen(true)

      return
    }

    await navigator.share(data).catch(e => {
      console.error('[Share] Failed to share natively', e)
    })

    this.reset()
  }

  @action
  #setOpen = x => {
    this.isOpen = x
  }

  @action
  #setShareData = x => {
    this.shareData = x
  }

  @action
  #setDialogData = x => {
    this.dialogData = x
  }
}
